// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainview {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  z-index: 1;
}

.mainview-sidebar {
  background-color: var(--dialog-background-color);
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  padding: var(--dialog-padding);
  align-items: center;
  width: 33%;
  max-width: 800px;
  min-width: 400px;
  box-sizing: border-box;
  border-right: 1px solid var(--border-color);
  overflow: auto;

  > h1 {
    margin: var(--dialog-element-gap) 0;
  }
}

.mainview-sidebar-contents,
.mainview-sidebar-contents > * {
  width: 100%;
}

.mainview-sidebar-contents > *:not(:last-child) {
  margin-bottom: var(--dialog-element-gap);
}

.mainview-content {
  flex-grow: 1;
  position: relative;
}

.mainview-dialogs {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.mainview-content-overlay {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: absolute;
  background-color: var(--blue-background-color);
}

.mainview-flavr-logo {
  max-width: 40%;
}

.mainview-sidebar-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--dialog-element-gap);
  width: 100%;
}

.mainview-sidebar-spacer {
  flex-grow: 1;
  height: var(--dialog-element-gap);
}

.mainview-avatar-large {
  width: 400px;
}

.mainview-avatar-small {
  width: calc(var(--input-element-height) * 2);
}

.mainview-popup-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 500px;
  background-color: var(--dialog-background-color);
  padding: var(--dialog-padding);
  padding-bottom: calc(var(--dialog-padding) * 2);
  border-top-right-radius: var(--dialog-border-radius);

  > h2 {
    margin-top: 0;
  }
}

.mainview-sidebar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--dialog-element-gap);
  padding-bottom: var(--dialog-element-gap);
  width: 100%;

  > h1 {
    margin: 0;
  }
}

@media (max-width: 850px) {
  .mainview-content,
  .mainview-content-overlay {
    display: none;
  }
  .mainview-sidebar {
    max-width: 100%;
    width: 100%;
    border-right: none;
  }
}

@media (max-height: 900px) {
  .mainview-sidebar-header {
    flex-direction: row;
    justify-content: center;
    gap: calc(var(--dialog-element-gap) * 2);
  }
  .mainview-flavr-logo {
    max-height: 250px;
  }
}

@media (max-height: 800px) {
  .mainview-flavr-logo {
    max-height: 175px;
  }
}

@media (max-height: 650px) {
  .mainview-flavr-logo {
    max-height: 100px;
  }
}

@media (max-height: 580px) {
  .mainview-sidebar-header {
    padding-bottom: 0;
  }
  .mainview-flavr-logo {
    display: none;
  }
}

@media (max-height: 520px) {
  .mainview-sidebar-header {
    > h1 {
      font-size: var(--font-size-xl);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/main-view/MainView.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,cAAc;;EAEd;IACE,mCAAmC;EACrC;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,gDAAgD;EAChD,8BAA8B;EAC9B,+CAA+C;EAC/C,oDAAoD;;EAEpD;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,WAAW;;EAEX;IACE,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;EAC1C;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE;MACE,8BAA8B;IAChC;EACF;AACF","sourcesContent":[".mainview {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  z-index: 1;\n}\n\n.mainview-sidebar {\n  background-color: var(--dialog-background-color);\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  padding: var(--dialog-padding);\n  align-items: center;\n  width: 33%;\n  max-width: 800px;\n  min-width: 400px;\n  box-sizing: border-box;\n  border-right: 1px solid var(--border-color);\n  overflow: auto;\n\n  > h1 {\n    margin: var(--dialog-element-gap) 0;\n  }\n}\n\n.mainview-sidebar-contents,\n.mainview-sidebar-contents > * {\n  width: 100%;\n}\n\n.mainview-sidebar-contents > *:not(:last-child) {\n  margin-bottom: var(--dialog-element-gap);\n}\n\n.mainview-content {\n  flex-grow: 1;\n  position: relative;\n}\n\n.mainview-dialogs {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.mainview-content-overlay {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  position: absolute;\n  background-color: var(--blue-background-color);\n}\n\n.mainview-flavr-logo {\n  max-width: 40%;\n}\n\n.mainview-sidebar-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--dialog-element-gap);\n  width: 100%;\n}\n\n.mainview-sidebar-spacer {\n  flex-grow: 1;\n  height: var(--dialog-element-gap);\n}\n\n.mainview-avatar-large {\n  width: 400px;\n}\n\n.mainview-avatar-small {\n  width: calc(var(--input-element-height) * 2);\n}\n\n.mainview-popup-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 500px;\n  background-color: var(--dialog-background-color);\n  padding: var(--dialog-padding);\n  padding-bottom: calc(var(--dialog-padding) * 2);\n  border-top-right-radius: var(--dialog-border-radius);\n\n  > h2 {\n    margin-top: 0;\n  }\n}\n\n.mainview-sidebar-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--dialog-element-gap);\n  padding-bottom: var(--dialog-element-gap);\n  width: 100%;\n\n  > h1 {\n    margin: 0;\n  }\n}\n\n@media (max-width: 850px) {\n  .mainview-content,\n  .mainview-content-overlay {\n    display: none;\n  }\n  .mainview-sidebar {\n    max-width: 100%;\n    width: 100%;\n    border-right: none;\n  }\n}\n\n@media (max-height: 900px) {\n  .mainview-sidebar-header {\n    flex-direction: row;\n    justify-content: center;\n    gap: calc(var(--dialog-element-gap) * 2);\n  }\n  .mainview-flavr-logo {\n    max-height: 250px;\n  }\n}\n\n@media (max-height: 800px) {\n  .mainview-flavr-logo {\n    max-height: 175px;\n  }\n}\n\n@media (max-height: 650px) {\n  .mainview-flavr-logo {\n    max-height: 100px;\n  }\n}\n\n@media (max-height: 580px) {\n  .mainview-sidebar-header {\n    padding-bottom: 0;\n  }\n  .mainview-flavr-logo {\n    display: none;\n  }\n}\n\n@media (max-height: 520px) {\n  .mainview-sidebar-header {\n    > h1 {\n      font-size: var(--font-size-xl);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
